define('app/sdc/wizard/step/sdc-wizard-step',["$animate", "$q"], function ($animate, $q) {
	return {
		restrict: "AE",
		require: {
			"owner": "^?sdc-wizard"
		},
		priority: 200,
		scope: false,
		transclude: "element",
		template: null,
		controller: {
			defaults: {
				"canCompleteStep": function () { return true; }
			},
			bind: {
				"sdcWizardStep": "&?",
				"completeStep": "&?",
				"canCompleteStep": "&?",
				"previousText": "@?",
				"nextText": "@?",
			},
			constructor: ["$self", "$transclude", "$element", "$attrs", function (vm, $transclude, $element, $attrs) {
				vm.completeStep = vm.completeStep || vm.sdcWizardStep;
				vm.transclude = function transclude() {
					var animationPromise,
						deferred = {
							animation: $q.defer(),
						};
					deferred.transclude = $q(function ($return, $throw) {
						vm;
						$transclude(function (clone, scope) {
							try {
								$return(clone);
								animationPromise = $animate.enter(clone, $element.parent(), $element).then(
									deferred.animation.resolve.bind(deferred.animation),
									deferred.animation.reject.bind(deferred.animation),
									deferred.animation.notify.bind(deferred.animation));
							}
							catch (ex) {
								$throw(ex);
								deferred.animation.reject(ex);
							}
						});
					})
					return angular.extend(deferred.animation.promise, {
						destroy: destroy
					});
					function destroy() {
						deferred.transclude.then(function (clone) {
							if (animationPromise) {
								$animate.cancel(animationPromise);
							}
							return $animate.leave(clone);
						});
					}
				};
			}]
		},
		link: ["$self", "$scope", function (vm, $scope) {
			$scope.$on("$destroy", vm.owner.registerStep(vm));
		}]
	};
});
